import { useState } from "react";
import { Icon, Logo, Mark, BlobField, Button } from "../../components/ui";
import { useAuthController } from "../../controllers/useAuthController";
import { validateRequiredForm } from "../../utils/validate";

const TRUST = [
  {
    icon: "lock",
    t: "Secure staff access",
    d: "Sign in with your assigned centre or group credentials.",
  },
  {
    icon: "shield",
    t: "Role-based permissions",
    d: "Every screen respects what your role is allowed to see and do.",
  },
  {
    icon: "forms",
    t: "Everything in one place",
    d: "Registrations, families, forms, handbook and documents — managed together.",
  },
];

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loading, error, handleLogin, clearError } = useAuthController();

  const submit = async (e) => {
    e.preventDefault();
    clearError();
    if (!validateRequiredForm(e.currentTarget)) return;
    await handleLogin({ email, password });
  };

  return (
    <div className="login-wrap">
      <div className="login-hero on-dark">
        <BlobField />
        <div className="login-hero-inner">
          <div className="hero-brand">
            <Mark size={52} variant="amber" />
            <Logo variant="white" height={44} />
          </div>
          <div className="hero-spacer">
            <p className="eyebrow on-dark">Admin Portal</p>
            <h1 className="display hero-title">
              Manage your families,
              <br />
              forms and content.
            </h1>
            <div className="trust-list">
              {TRUST.map((b) => (
                <div key={b.t} className="trust-item">
                  <span className="trust-ico">
                    <Icon name={b.icon} />
                  </span>
                  <div>
                    <div className="trust-t">{b.t}</div>
                    <div className="trust-d">{b.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="hero-tagline">Steps towards a bright future.</p>
        </div>
      </div>

      <div className="login-form-side">
        <form className="login-card" onSubmit={submit} noValidate>
          <p className="eyebrow">Sign in</p>
          <h2 className="auth-h2">Hello again</h2>
          <p className="auth-intro">Enter your credentials to access the admin panel.</p>

          {error && <div className="alert-soft">{error}</div>}

          <div className="form-field">
            <label className="field-label" htmlFor="admin-login-email">
              Email address
            </label>
            <input
              id="admin-login-email"
              className="input"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@strideearlylearning.wa.edu.au"
              autoFocus
              required
            />
          </div>

          <div className="form-field">
            <label className="field-label" htmlFor="admin-login-password">
              Password
            </label>
            <input
              id="admin-login-password"
              className="input"
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              required
            />
          </div>

          <Button
            variant="primary"
            block
            type="submit"
            disabled={loading}
            iconRight={loading ? null : "chevronRight"}
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="login-foot">Need help? Contact your group administrator.</p>
      </div>
    </div>
  );
}
